import {useEffect, useState} from "react";

const INITIAL_STATE = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  currentSku: null,
  error: null,
};

const useAddToCartStatus = () => {
  const [state, setState] = useState(INITIAL_STATE);

  useEffect(() => {
    const onStart = (e) => {
      setState({
        isLoading: true,
        isSuccess: false,
        isError: false,
        currentSku: e.detail.sku,
        error: null,
      });
    };

    const onDone = (e) => {
      setState({
        isLoading: false,
        isSuccess: true,
        isError: false,
        currentSku: e.detail.sku,
        error: null,
      });
      setTimeout(() => { setState(INITIAL_STATE); }, 2000);
    };

    const onError = (e) => {
      setState({
        isLoading: false,
        isSuccess: false,
        isError: true,
        currentSku: e.detail.sku,
        error: e.detail.error,
      });
      setTimeout(() => { setState(INITIAL_STATE); }, 2000);
    };

    window.addEventListener("addToCart:start", onStart);
    window.addEventListener("addToCart:done", onDone);
    window.addEventListener("addToCart:error", onError);

    return () => {
      window.removeEventListener("addToCart:start", onStart);
      window.removeEventListener("addToCart:done", onDone);
      window.removeEventListener("addToCart:error", onError);
    };
  }, []);

  return state;
};

export default useAddToCartStatus;
